module.exports = __webpack_public_path__ + "img/gs90-2.bbe78efd.jpg";